import { Code } from '@gasbi/shared/common/utils/validateCodeFn';

import http from '@/utils/http';

const EIC_GAS_SUPPLY_STATION_LENGTH = 16;

/**
 * The `validateCodeFn` of the shared ГРМ form (PO, 2026-10-27): a yup test that asks the BMS card's route
 * (gdn-organizations) whether the ЕІС ГТС has a valid format, the only code the form checks on the server. A code is
 * sent once it has its full length, so a half-typed one sends no request; uniqueness is checked when the card is saved.
 */
export const validateCodeFn =
  (key: Code) =>
  async (value?: string | null): Promise<boolean> => {
    if (
      key !== Code.EicGasSupplyStation ||
      value?.length !== EIC_GAS_SUPPLY_STATION_LENGTH
    ) {
      return true;
    }

    try {
      const { data } = await http<{ isValid: boolean }>({
        url: '/gdn-organizations/eic-gas-supply-station/validate',
        params: { [key]: value },
      });
      return data.isValid;
    } catch {
      return false;
    }
  };
